<template>
  <div class="tw-text-right">
    <div v-if="$userLoadStatus.value == 'loaded'">
      <div v-if="currentUser !== null">
        <div class="tw-text-xl tw-font-bold tw-uppercase">
          <a href="" @click.prevent="logout" class="tw-no-underline">
            Logout
          </a>
        </div>
        <ViewAsSomeoneElse />
      </div>
      <div v-else>
        <LoginModal
          v-if="isLoginVisible"
          @closed="showLogin(false)"
        />
        <div class="tw-text-xl tw-font-bold tw-uppercase">
          <SfRouterLink to="/register" class="tw-no-underline">
            Register
          </SfRouterLink>
          /
          <a
            href=""
            @click.prevent="showLogin(true)"
            class="tw-no-underline"
          >
            Login
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { SfUser } from "@/types/generalTypes";
import { loginVisible, refreshUser, setLoginVisible } from "@/state/appState";
import SfRouterLink from "@/components/shared/SfRouterLink.vue";
import apiCall from "@/func/net/apiCall";
import LoginModal from "./LoginModal.vue";
import ViewAsSomeoneElse from "./ViewAsSomeoneElse.vue";

export default defineComponent({
  components: { LoginModal, ViewAsSomeoneElse, SfRouterLink },
  data() {
    return {
    };
  },
  computed: {
    currentUser(): SfUser | null {
      return this.$currentUser.value;
    },
    isLoginVisible() {
      return loginVisible.value;
    },
  },
  mounted() {
    (window as any).sfGetVueUser = () => {
      return this.$currentUser.value;
    };
    this.loadUserInfo();
  },
  methods: {
    async loadUserInfo() {
      await refreshUser();
      if(this.$route.query.login == '1' && !this.$currentUser.value) {
        this.showLogin(true);
      }
    },
    async logout() {
      const resData = await apiCall("auth/logout", null, { method: "POST" });
      if (resData.success) {
        window.location.href = "/";
      }
    },
    showLogin(show: boolean) {
      setLoginVisible(show);
    },
  },
});
</script>
